/** Browser HTTP wait. Must stay above HandleMessage (55 min) and below Cloud Run (60 min). */
export const HANDLE_MESSAGE_HTTP_TIMEOUT_MS = 59 * 60 * 1000;

